import React from 'react';
import Link from 'gatsby-link';
import { withPrefix } from "gatsby-link";
import { FaMapMarker, FaCubes, FaExternalLink, FaPaperPlane, FaWrench, FaMale, FaChevronDown, FaChevronUp, FaInbox } from 'react-icons/lib/fa';
import GoTools from "react-icons/lib/go/tools";
import MdComputer from "react-icons/lib/md/computer";
import { TiCodeOutline } from 'react-icons/lib/ti';

const ListLink = (props) => {
  if(props.to != 'playground')
    return(
        <li className="c-main-nav__elem" >
        <Link
            to={props.to}
            className="c-main-nav__link"
            activeClassName="c-main-nav__link--is-active"
            exact={true}
            onClick={props.closeMenu}
        >
        {props.children}
        </Link>
        </li>);
  else return(
        <li className="c-main-nav__elem">
            <a
                href="https://blog.robertogentile.org/"
                className="c-main-nav__link"
                onClick={props.closeMenu}
            >
            {props.children}
            </a>
        </li>)
};

const generateLink = (link, currentPath) => {
    const isLinkEN = currentPath.search('/en/');
    const isLinkIT = currentPath.search('/it/');
    if((isLinkEN != -1)||((isLinkEN == -1)&&(isLinkIT == -1))) return '/en/' + link
    else return '/it/' + link
};

class MainNav extends React.Component {
  constructor(props) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this)
    this.state = {
      links: [
        { to: generateLink('', this.props.pathname), text: 'Home', icon: FaMapMarker },
        { to: generateLink('apps', this.props.pathname), text: 'Apps', icon: MdComputer },
        { to: generateLink('work', this.props.pathname), text: 'Work', icon: GoTools },
        { to: generateLink('toolbox', this.props.pathname), text: 'Toolbox', icon: FaInbox },
        { to: 'playground', text: 'Playground', icon: FaPaperPlane },
        { to: generateLink('about', this.props.pathname), text: 'About Rob', icon: FaMale },
      ],
      mainNavModifierClassName: '',
      mobileDetailsNav: null
    }
  }

  closeMenu() {
    console.log('closeMenu()');
    if (this.state.mobileDetailsNav) {
      this.setState(() => ({
        mainNavModifierClassName: '',
        mobileDetailsNav: null
      }))
    }
  }

  toggleMenu() {
    let mobileDetailsNav = null;
    let mainNavModifierClassName = '';

    if (!this.state.mobileDetailsNav) {
      mobileDetailsNav = (
        <div className="c-main-nav c-main-nav--is-open">
        {
          this.state.links.map((link, i) => (
            <ListLink closeMenu={this.closeMenu} to={link.to} key={i} >
              <link.icon />
              <span className="c-main-nav__text">{link.text}</span>
            </ListLink>
          ))
        }
        </div>
      );
      mainNavModifierClassName = 'c-main-nav--is-hidden'
    }

    this.setState(() => ({
      mainNavModifierClassName: mainNavModifierClassName,
      mobileDetailsNav: mobileDetailsNav
    }));
  }

  render() {
    return (
      <div>
        <ul className={ `c-main-nav ${this.state.mainNavModifierClassName}` }>
          {
            this.state.links.map((link, i) => (
              <ListLink to={link.to} key={i} testLink={this.testLink}>
                <link.icon />
                <span className="c-main-nav__text">{link.text}</span>
              </ListLink>
            ))
          }
          <li
            className="c-main-nav__elem c-main-nav__elem--close-link"
            onClick={this.toggleMenu}
          >
            <a href="#" className="c-main-nav__link">
              { (this.state.mainNavModifierClassName) ? <FaChevronUp /> : <FaChevronDown />  }
              <span className="c-main-nav__text">Close</span>
            </a>
          </li>
        </ul>
        { this.state.mobileDetailsNav }
      </div>
    )
  }
};

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/MainNav.jsx